module.exports = __webpack_public_path__ + "media/images/new-ui-images/user-follow-4c26781e7c13bbece41067abf185ea7d.svg";